import { render, staticRenderFns } from "./administrationMenu.vue?vue&type=template&id=21f7851d&scoped=true&"
import script from "./administrationMenu.vue?vue&type=script&lang=js&"
export * from "./administrationMenu.vue?vue&type=script&lang=js&"
import style0 from "./administrationMenu.vue?vue&type=style&index=0&id=21f7851d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f7851d",
  null
  
)

export default component.exports